class Breadcrumbs {

    constructor($rootScope, $routeParams, ApiService, UserService, CONTENT_TYPE) {
        
        this.$rootScope = $rootScope;
        this.$routeParams = $routeParams;
        this.ApiService = ApiService;
        this.UserService = UserService;
        this.CONTENT_TYPE = CONTENT_TYPE;

        this.entities = {};
        this.clientId = "";
        this.accountId = "";
        this.advertiserId = "";                
        this.campaignId = "";

        let _self = this;        

        return {
            restrict: 'E',
            templateUrl: "components/breadcrumbs-directive.html",
            scope: {
            	titlePrefix: "@",
                entityType: "@",
                leaf: "@"
            },
            link: ($scope, $el, $attr) => {
                
                $scope.isLeaf = false;
                if($scope.leaf === "true") {
                    $scope.isLeaf = true;
                }

                $scope.title = "";
                $scope.breadcrumbs = [
                    { url: "/accounts", name: "Accounts" }
                ];

                if(!this.updateEntityIds($scope)) {
                    this.startCalculateBreadcrumbs($scope);
                }

                $rootScope.$watch("currentUser.selectedClientId", () => {
                    if($scope.entityType === this.CONTENT_TYPE.CLIENT) {
                        if(!this.updateEntityIds($scope)) {
                            this.startCalculateBreadcrumbs($scope);
                        }
                    }
                });

			}
		};

	}

    getEntity($scope, contentType, entityId) {

        if(!entityId) {
            this.entities[contentType] = null;
        }
        else {
            this.ApiService.get(contentType, entityId)
                .then(resp => {
                    this.entities[contentType] = { id: resp.data.id, name: resp.data.name };
                    this.startCalculateBreadcrumbs($scope);
                    $scope.$applyAsync();
                },
                () => {
                    this.entities[contentType] = { id: 0, name: "Not found" };
                });
        }

    }

    updateEntityIds($scope) {

        var willGetEntity = false;

        willGetEntity = this.setClientId($scope, this.$rootScope.currentUser.selectedClientId) || willGetEntity;

        if(this.$routeParams.hasOwnProperty('accountId')) {
            willGetEntity = this.setAccountId($scope, this.$routeParams.accountId) || willGetEntity;
        }

        if(this.$routeParams.hasOwnProperty('advertiserId')) {
            willGetEntity = this.setAdvertiserId($scope, this.$routeParams.advertiserId) || willGetEntity;
        }

        if(this.$routeParams.hasOwnProperty('campaignId')) {
            willGetEntity = this.setCampaignId($scope, this.$routeParams.campaignId) || willGetEntity;
        }

        if(this.$routeParams.hasOwnProperty('feedId')) {
            willGetEntity = this.setFeedId($scope, this.$routeParams.feedId) || willGetEntity;
        }

        if(this.$routeParams.hasOwnProperty('creativeId')) {
            willGetEntity = this.setCreativeId($scope, this.$routeParams.creativeId) || willGetEntity;
        }

        return willGetEntity;

    }

    startCalculateBreadcrumbs($scope) {
        

        $scope.breadcrumbs = [];
        if($scope.isLeaf) {
            $scope.breadcrumbs.push({ url: "", name: $scope.titlePrefix });
        }

        this.calculateBreadcrumbs($scope, $scope.entityType);

        try {
            switch($scope.entityType) {
            
            case this.CONTENT_TYPE.CREATIVE:
                $scope.title = this.entities[this.CONTENT_TYPE.CAMPAIGN].name + " - " + this.entities[this.CONTENT_TYPE.CREATIVE].name;
                break;

            case this.CONTENT_TYPE.FEED:
                $scope.title = this.entities[this.CONTENT_TYPE.ADVERTISER].name + " - " + this.entities[this.CONTENT_TYPE.FEED].name;
                break;

            case this.CONTENT_TYPE.CAMPAIGN:
                $scope.title = this.entities[this.CONTENT_TYPE.ADVERTISER].name + " - " + this.entities[this.CONTENT_TYPE.CAMPAIGN].name;
                break;

            case this.CONTENT_TYPE.ADVERTISER:
                $scope.title = this.entities[this.CONTENT_TYPE.ACCOUNT].name + " - " + this.entities[this.CONTENT_TYPE.ADVERTISER].name;
                break;

            case this.CONTENT_TYPE.ACCOUNT:
                $scope.title = this.entities[this.CONTENT_TYPE.ACCOUNT].name;
                break;

            case this.CONTENT_TYPE.CLIENT:
                $scope.title = this.entities[this.CONTENT_TYPE.CLIENT].name;
                break;
            }
        }
        catch(e) {
            // NOOP
        }
    }

    calculateBreadcrumbs($scope, entityType) {

        try {

            switch(entityType) {

            case this.CONTENT_TYPE.FEED:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId + "/" + this.advertiserId + "/feed/" + this.feedId, 
                    name: this.entities[this.CONTENT_TYPE.FEED].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.ADVERTISER);
                break;

            case this.CONTENT_TYPE.CREATIVE:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId + "/" + this.advertiserId + "/campaign/" + this.campaignId + "/creatives", 
                    name: this.entities[this.CONTENT_TYPE.CREATIVE].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.CAMPAIGN);
                break;

            case this.CONTENT_TYPE.CAMPAIGN:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId + "/" + this.advertiserId + "/campaign/" + this.campaignId, 
                    name: this.entities[this.CONTENT_TYPE.CAMPAIGN].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.ADVERTISER);
                break;

            case this.CONTENT_TYPE.ADVERTISER:

                let crumb = { 
                    url: "/account/" + this.accountId + "/" + this.advertiserId, 
                    name: this.entities[this.CONTENT_TYPE.ADVERTISER].name
                };

                if($scope.entityType === "feed") {
                    crumb.url += "/feeds";
                }

                if($scope.entityType === "campaign") {
                    crumb.url += "/campaigns";
                }

                $scope.breadcrumbs.unshift(crumb);

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.ACCOUNT);
                break;

            case this.CONTENT_TYPE.ACCOUNT:

                $scope.breadcrumbs.unshift( { 
                    url: "/account/" + this.accountId,
                    name: this.entities[this.CONTENT_TYPE.ACCOUNT].name
                });

                this.calculateBreadcrumbs($scope, this.CONTENT_TYPE.CLIENT);
                break;

            case this.CONTENT_TYPE.CLIENT:
                $scope.breadcrumbs.unshift( { url: "/accounts", name: "Accounts" } );
                break;
            }

        }
        catch(e) {
            // NOOP
        }
    }

    setFeedId($scope, entityId) {
        var willGetEntity = false;
        if(entityId != this.feedId) {
            this.feedId = entityId;
            this.getEntity($scope, this.CONTENT_TYPE.FEED, entityId);
            willGetEntity = true;
        }
        return willGetEntity;
    }

    setCreativeId($scope, entityId) {
        var willGetEntity = false;
        if(entityId != this.creativeId) {
            this.creativeId = entityId;
            this.getEntity($scope, this.CONTENT_TYPE.CREATIVE, entityId);
            willGetEntity = true;
        }
        return willGetEntity;
    }

    setCampaignId($scope, entityId) {
        var willGetEntity = false;
        if(entityId != this.campaignId) {
            this.campaignId = entityId;
            this.getEntity($scope, this.CONTENT_TYPE.CAMPAIGN, entityId);
            willGetEntity = true;
        }
        return willGetEntity;
    }

    setAdvertiserId($scope, entityId) {
        var willGetEntity = false;
        if(entityId != this.advertiserId) {
            this.advertiserId = entityId;
            this.getEntity($scope, this.CONTENT_TYPE.ADVERTISER, entityId);
            willGetEntity = true;
        }
        return willGetEntity;
    }

    setAccountId($scope, entityId) {
        var willGetEntity = false;
        if(entityId != this.accountId) {
            this.accountId = entityId;
            this.getEntity($scope, this.CONTENT_TYPE.ACCOUNT, entityId);
            willGetEntity = true;
        }
        return willGetEntity;
    }

    setClientId($scope, entityId) {
        var willGetEntity = false;
        if(entityId === "*") {
            this.entities[this.CONTENT_TYPE.CLIENT] = { name: "All Clients" };
        }
        else if(entityId != this.clientId) {
            this.clientId = entityId;
            this.getEntity($scope, this.CONTENT_TYPE.CLIENT, entityId);
            willGetEntity = true;
        }
        return willGetEntity;
    }

}

angular.module('cpm')
    .directive('breadcrumbs', ['$rootScope', "$routeParams", "ApiService", "UserService", "CONTENT_TYPE", ($rootScope, $routeParams, ApiService, UserService, CONTENT_TYPE) => {
        'use strict';
        return new Breadcrumbs($rootScope, $routeParams, ApiService, UserService, CONTENT_TYPE);
    }]);
